module.exports = ({
    // 401
    "CDMS402MSG011": "ไม่พบหน้าที่บันทึกไว้",
    "CDMS401P001": "ความคิดเห็น...",
    "CDMS401MSG001": "ไม่มีข้อมูล {label}",
    "CDMS401MSG002": "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากยังมีคำถามเปิดค้างอยู่",
    "CDMS401MSG003": "ไม่สามารถเพิ่ม {type} อัตโนมัติได้",
    "CDMS401MSG004": "คุณแน่ใจหรือไม่ว่าต้องการเพิ่มเข้าร่วมวิจัยใหม่?",
    "CDMS401MSG005": "รหัสเข้าร่วมวิจัยนี้ถูกใช้งานแล้ว",
    "CDMS401BTN001": "แก้ไข",
    "CDMS401LB001": "【ความคิดเห็น】",
    "CDMS400MSG009": "หมายเลขการคัดกรองต้องน้อยกว่าหรือเท่ากับ 256 อักขระ",
    "CDMS400MSG010": "หมายเลขการลงทะเบียนต้องน้อยกว่าหรือเท่ากับ 256 อักขระ",
    "CDMS402MSG001": "โปรดป้อนเนื้อหาคำถามของ Query",
    "CDMS402MSG002": "โปรดป้อนเนื้อหาคำตอบของ Query",
    "CDMS402MSG003": "มี Query เกิดขึ้นจำนวน {count} รายการ",
    "CDMS402MSG004": "โปรดระบุเหตุผลในการแก้ไข",
    "CDMS402MSG005": "คุณต้องการบันทึกข้อมูลหรือไม่?",
    "CDMS402BTN001": "รายการผู้เข้าร่วมวิจัย",
    "CDMS402BTN002": "หน้าถัดไป",
    "CDMS402BTN003": "แก้ไข",
    "CDMS402BTN004": "ตอบ Query",
    "CDMS402BTN005": "แก้ไขคำตอบ",
    "CDMS402BTN006": "ปิด/เปิด Query ใหม่",
    "CDMS402BTN007": "Visit&Form Matrix",
    "CDMS402LB001": "【Query】",
    "CDMS402LB003": "หากมีการแก้ไขข้อมูลหลายครั้ง และต้องการใช้เหตุผลการแก้ไขเดียวกัน กรุณาเลือก “ใช่” หากไม่ใช่เหตุผลเดียวกันให้เลือก “ไม่ใช่”",
    "CDMS402LB004": "กรุณาเลือกหัวข้อที่ต้องการสร้าง Query",
    "CDMS402LB005": "กรุณากรอกเนื้อหาของ Query",
    "CDMS402LB006": "กรุณาเลือกผลลัพธ์ของ Query",
    "CDMS402LB007": "บรรทัดที่ {line}",
    "CDMS402TT001": "เหตุผลในการแก้ไข",
    "CDMS402TT002": "สร้าง Query",
    "CDMS402TT003": "คำตอบ",
    "CDMS402TT004": "แก้ไขคำตอบ",
    "CDMS402OPT001": "การป้อนข้อมูลผิดพลาด",
    "CDMS402OPT002": "ข้อมูลใหม่",
    "CDMS402OPT003": "แก้ไข Source Data",
    "CDMS402OPT004": "อื่นๆ",
    "CDMS402OPT005": "ลบ",
    "CDMS402OPT006": "แก้ไขเนื้อหา",
    "CDMS402OPT007": "ปิด Query",
    "CDMS402OPT008": "เปิด Query ใหม่",
    "CDMS402OPT009": "System",
    "CDMS402OPT010": "Manual",
    "CDMS402OPT011": "Open",
    "CDMS402OPT012": "Answered ",
    "CDMS402OPT013": "Closed",
    "CDMS402OPT014": "Reopen",
    "CDMS402HL001": "Data Audit Trail",
    "CDMS402HL002": "Query Audit Trail",
    "CDMS402HL003": "Comment Audit Trail",
    "CDMS402HL004": "Signature Audit Trail",
    "CDMS402HL005": "SDV Audit Trail",
    "CDMS402HL006": "Review Audit Trail",
    "CDMS402HL007": "Lock Audit Trail",
    "CDMS402HL008": "Freeze Audit Trail",
    "CDMS402H001": "วันและเวลา",
    "CDMS402H002": "ผู้ใช้",
    "CDMS402H003": "รายการแก้ไข",
    "CDMS402H004": "ก่อนแก้ไข",
    "CDMS402H005": "หลังแก้ไข",
    "CDMS402H006": "เหตุผล",
    "CDMS402H007": "รายการ",
    "CDMS402H008": "หมายเลขกลุ่ม",
    "CDMS402H009": "ประเภท",
    "CDMS402H010": "Query",
    "CDMS402H011": "สถานะ",
    "CDMS402H012": "คำตอบ",
    "CDMS402H013": "ความคิดเห็น",
    "CDMS402H014": "คำถาม",
    "CDMS402H015": "No.",
    "CDMS402MSG006": "ไม่สามารถตั้งค่าสถานะได้เนื่องจากรายการนี้ถูกล็อก จึงตั้งค่าสถานะได้เฉพาะรายการที่ไม่ไม่ถูกล็อกเท่านั้น",
    "CDMS500MSG001": "ไม่สามารถกรอกข้อมูลในหน้านี้ได้ เนื่องจากหน้าลงทะเบียนมีอยู่แล้ว",
    "CDMS402MSG007": "การสุ่มกลุ่มของเข้าร่วมวิจัยเสร็จสมบูรณ์และบันทึกข้อมูลเรียบร้อยแล้ว",
    "CDMS402MSG008": "ไม่มีปัจจัยที่ใช้ในการสุ่มสำหรับผู้ป่วยรายนี้ได้ จึงไม่สามารถดำเนินการสุ่มได้",
    "CDMS402MSG009": "ไม่สามารถเลือก ARM ให้ผู้ป่วยรายนี้ได้ เพราะข้อมูลปัจจัยไม่ตรงตามเงื่อนไข จึงไม่สามารถทำการสุ่มได้",
    "CDMS402MSG010": "ไม่สามารถสุ่มกลุ่มสำหรับผู้เข้าร่วมวิจัยรายนี้ได้ เนื่องจากไม่พบ IP No.",
    "CDMS402MSG012": "การสุ่มกลุ่มดำเนินการเสร็จสิ้นแล้ว แต่ไม่สามารถบันทึกหน้าข้อมูลได้",
    "CDMS402MSG015": "คุณแน่ใจหรือไม่ว่าต้องการสุ่มกลุ่มให้กับเข้าร่วมวิจัยรายนี้?"
});